import * as _ from 'lodash'
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";
import {PartitionBO} from "./PartitionBO";

export class PartitionBOValidations {

    static ValidateEmptyFields(aBO: PartitionBO): Promise<void> {

        return new Promise((resolve, error) => {
            if (!aBO.WB_Partition.isActive) {
                resolve()
                return
            }

            if (_.isEmpty(aBO.WB_Partition.cif.PARTITION_ID) || _.isNull(aBO.WB_Partition.cif.PARTITION_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyId',
                        type: MessageType.Error,
                        title: "Partition ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_Partition.cif.PARTITION_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'Emptyname',
                        type: MessageType.Error,
                        title: "Partition Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('Emptyname')
            }

            if ((aBO.WB_Partition.cif.WB_MDSET_ID == 0) || _.isUndefined(aBO.WB_Partition.cif.WB_MDSET_ID) || _.isNull(aBO.WB_Partition.cif.WB_MDSET_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'MDSetId',
                        type: MessageType.Error,
                        title: "Master Data Set cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('MDSetId')
            }

            if ((aBO.WB_Partition.cif.HIERARCHY_DT == '') || _.isUndefined(aBO.WB_Partition.cif.HIERARCHY_DT)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'hierarchyDt',
                        type: MessageType.Error,
                        title: "Hierarchy Date cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('hierarchyDt')
            }
            resolve()
        })
    }

}